const moment = require("moment")


const calculateTimeDifference = (dbDate) => {
    let duration = moment.duration(moment().diff(moment(dbDate)))

    if (duration.asMinutes() < 60) {
        let count = parseInt(duration.asMinutes())
        return `${count} min${count <= 1 ? '' : 's'} ago`;
    }

    if (duration.asHours() < 24) {
        let count = parseInt(duration.asHours())
        return `${count} hour${count <= 1 ? '' : 's'} ago`;
    }

    if (duration.asDays() < 7) {
        let count = parseInt(duration.asDays())
        return `${count} day${count <= 1 ? '' : 's'} ago`;
    }

    let count = parseInt(duration.asWeeks())
    return `${count} week${count <= 1 ? '' : 's'} ago`;
}

export {
    calculateTimeDifference
}